module.exports = __webpack_public_path__ + "img/u8589.e4b4785b.svg";